





























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import AgencyRoles from '@/components/AgencyRoles/AgencyRoles.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';

@Component({
	name: 'AgencyRoleSettings',
  	components: { AgencyRoles, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getAgencyRoles();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingAgencyRoles;
  	}
}
